<template>
    <van-popup
        v-model="isShow"
        position="bottom"
        :duration="0.1"
        :style="{ height: '320px' }"
        :closeable="true"
        :safe-area-inset-bottom="true"
        :close-on-click-overlay="false"
    >
        <div class="title">请填写报名信息</div>
        <template v-if="isShow">
            <div class="form-item">
                <div class="label" v-html="'姓&emsp;&emsp;名'"></div>
                <div class="content">
                    <input v-model="userName" placeholder="请填写真实姓名" />
                </div>
            </div>
            <div class="form-item">
                <div class="label" v-html="'手&ensp;机&ensp;号'"></div>
                <div class="content">
                    <input type="number" v-model="userTel" placeholder="请填写有效的手机号" />
                </div>
            </div>
            <div class="form-item">
                <div class="label">支付方式</div>
                <div class="content">
                    <van-radio-group v-model="payType" direction="horizontal">
                        <van-radio v-for="item in payTypeList" :key="item" :name="item" checked-color="#07c160">
                            <span v-if="item === 'wxpay'">微信支付</span>
                            <span v-if="item === 'alipay'">支付宝付款</span>
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="submit-btn" @click="onSubmit">提交订单</div>
            <div class="user-agm" v-if="coursePriceInfo.sellExtra && coursePriceInfo.sellExtra.agreementId">
                <van-checkbox shape="square" checked-color="#07c160" v-model="agmChecked">
                    <span>我已阅读并同意</span>
                    <span class="agm-btn" @click.stop="isShowAgreement = true">《网络培训服务协议》</span>
                </van-checkbox>
            </div>
        </template>
        <van-popup
            v-model="isShowAgreement"
            :duration="0.1"
            get-container="body"
            :style="{ height: '80vh', width: '80vw' }"
            :closeable="true"
        >
            <iframe :src="agreementUrl"></iframe>
        </van-popup>
    </van-popup>
</template>
<script>
import { fetchOrder, getPayType, wxPay } from '@/utils/api'
import { getUserNameTel, setUserNameTel, urlQuery, isWeixin } from '@/utils/utils'

export default {
    props: ['userInfo', 'coursePriceInfo', 'liveInfo'],
    data() {
        return {
            isShow: false,
            userName: '',
            userTel: '',
            payType: 'wxpay',
            payTypeList: [],

            isShowAgreement: false,
            agmChecked: false,
        }
    },
    computed: {
        agreementUrl: function() {
            const packageInfo = this.coursePriceInfo
            let agmId = ''
            if (packageInfo && packageInfo.sellExtra && packageInfo.sellExtra.agreementId) {
                agmId = this.coursePriceInfo.sellExtra.agreementId
            }
            return `./agm.html?agmId=${agmId}`
        },
    },
    created() {
        const data = getUserNameTel()
        this.userName = data.userName
        this.userTel = data.userTel
        this.getPayTypeApi()
    },
    methods: {
        onShow() {
            this.agmChecked = false
            this.isShow = true
        },
        onSubmit() {
            const { userName, userTel, payType, coursePriceInfo, userInfo, agmChecked, liveInfo } = this
            if (!userName || !userTel) {
                return this.$toast('请填写完整信息')
            } else if (!new RegExp(/^1[0-9]{10}$/).test(userTel)) {
                return this.$toast('手机号格式错误')
            }
            setUserNameTel({ userName, userTel })

            if (!agmChecked && coursePriceInfo.sellExtra && coursePriceInfo.sellExtra.agreementId) {
                this.$dialog
                    .confirm({
                        className: 'confirm-dialog',
                        title: '友情提示',
                        message: `我已阅读并同意<span id="confirmDialogAgm">《网络培训服务协议》</span>`,
                        confirmButtonText: '同意并继续',
                        confirmButtonColor: '#44cd94',
                    })
                    .then(() => {
                        this.agmChecked = true
                        this.onSubmit()
                        document.onclick = null
                    })
                    .catch(() => {
                        document.onclick = null
                    })

                document.onclick = event => {
                    if (event.target.id === 'confirmDialogAgm') {
                        this.isShowAgreement = true
                    }
                }
                return
            }

            if (coursePriceInfo.price) {
                coursePriceInfo.totalFee = coursePriceInfo.price
                coursePriceInfo.paidFee = 0
            }
            // 正常支付
            const params = {
                userId: userInfo.id,
                productType: coursePriceInfo.productType ? coursePriceInfo.productType : 1,
                agreementStatus: false,
                packageNo: coursePriceInfo.packageNo,
                productNo: coursePriceInfo.packageNo,
                orderDetail: {
                    payFee: coursePriceInfo.totalFee - coursePriceInfo.paidFee,
                },
                userContact: {
                    userId: userInfo.id,
                    name: userName,
                    telNo: userTel,
                },
            }
            if (coursePriceInfo.sellExtra && coursePriceInfo.sellExtra.agreementId) {
                params.agreementStatus = true
            }

            // 拆单/定金支付
            if (coursePriceInfo.payCode) {
                params.orderDetail.payFee = coursePriceInfo.fee
                params.orderDetail.payCode = coursePriceInfo.payCode
            }

            if (payType === 'wxpay') {
                params.appId = window.WX_APPID
                params.openId = userInfo.openId
                params.orderDetail.tradeType = 'JSAPI'
                params.orderDetail.tradeProvider = 'wxpay'
            } else if (payType === 'alipay') {
                params.appId = window.ALI_APPID
                params.orderDetail.tradeType = 'wap_pay'
                params.orderDetail.tradeProvider = 'alipay'
            }

            const option = urlQuery()
            if (option.sn) {
                params.sourceType = 2
                params.sourceFrom = option.sn
            }

            // 直播间 打开支付
            if (liveInfo) {
                params.sourceFrom = liveInfo.liveId
                params.sourceType = 1
            }

            fetchOrder(params).then(res => {
                this.orderPay(res)
            })
        },
        orderPay(payData) {
            const { payType } = this
            if (payType === 'wxpay') {
                wxPay(
                    {
                        ...payData.data,
                        package: payData.data.packageValue,
                    },
                    data => {
                        if (data.err_msg === 'get_brand_wcpay_request:ok') {
                            this.$toast({
                                className: 'success-toast',
                                message: '支付成功',
                                duration: 2000,
                            })
                        } else if (data.err_msg === 'get_brand_wcpay_request:fail') {
                            this.$toast('支付失败')
                        }
                        this.$nextTick(() => {
                            this.$emit('paySuccess')
                            this.isShow = false
                        })
                    }
                )
            } else if (payType === 'alipay') {
                window.location.href = `./payment-m.html?payShortKey=${payData.data.payShortKey}`
            }
        },
        getPayTypeApi() {
            getPayType().then(res => {
                if (res.data) {
                    const list = res.data.split(',')
                    if (isWeixin()) {
                        this.payTypeList = list
                    } else {
                        this.payTypeList = list.filter(item => item !== 'wxpay')
                    }
                    this.payType = this.payTypeList[0]
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.title {
    line-height: 54px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
}
.form-item {
    padding: 6px 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
    height: 40px;
    border-bottom: 1px solid #eee;
    &:last-child {
        border: none;
    }
    .label {
        padding: 0 10px;
        color: #999;
        width: 60px;
    }
    .content {
        flex-grow: 1;
    }
    input,
    textarea {
        width: 100%;
        border: none;
    }
    textarea {
        margin-top: 14px;
        height: 28px;
        outline: none;
        resize: none;
        appearance: none;
    }
    .van-radio-group {
        margin-left: 5px;
        color: #666;
    }
}
.submit-btn {
    width: 200px;
    line-height: 36px;
    height: 36px;
    text-align: center;
    font-size: 14px;
    border-radius: 4px;
    background: #44cd94;
    color: #fff;
    margin: 24px auto 12px;
}
.user-agm {
    display: flex;
    align-items: center;
    justify-content: center;
    :deep(.van-checkbox) {
        display: flex;
        align-items: center;
        .van-checkbox__label {
            line-height: 18px;
            font-size: 13px;
        }
        .agm-btn {
            color: #44cd94;
        }
        .van-checkbox__icon--checked {
            .van-icon {
                color: #07c160;
                background: none !important;
                border-color: #07c160;
            }
        }
        .van-checkbox__icon {
            font-size: 14px;
        }
    }
}

iframe {
    width: 100%;
    margin: 0 auto;
    display: block;
    height: 100%;
}
</style>
<style lang="scss">
.confirm-dialog {
    #confirmDialogAgm {
        cursor: pointer;
        color: #44cd94;
    }
}
</style>
